import type { CountryCode } from 'libphonenumber-js'

const codes: CountryCode[] = [
  'HN',
  'DM',
  'FR',
  'DZ',
  'GA',
  'PH',
  'SS',
  'RW',
  'SD',
  'SE',
  'SR',
  'GW',
  'JP',
  'GB',
  'PK',
  'SG',
  'RU',
  'DO',
  'GT',
  'KW',
  'IL',
  'DK',
  'SB',
  'PY',
  'ST',
  'SC',
  'DJ',
  'GQ',
  'KR',
  'KE',
  'KG',
  'HK',
  'KP',
  'GD',
  'SA',
  'SV',
  'RS',
  'PL',
  'GR',
  'GE',
  'IN',
  'MV',
  'LR',
  'MA',
  'NZ',
  'AU',
  'BN',
  'BY',
  'TT',
  'UG',
  'YE',
  'BO',
  'AT',
  'LS',
  'MW',
  'NL',
  'MU',
  'BZ',
  'US',
  'TV',
  'AW',
  'CH',
  'MC',
  'MT',
  'NO',
  'LC',
  'MG',
  'LT',
  'AD',
  'CL',
  'BH',
  'UA',
  'TR',
  'TD',
  'BI',
  'AR',
  'CM',
  'AE',
  'CZ',
  'LU',
  'LB',
  'MD',
  'AG',
  'CO',
  'VN',
  'ZM',
  'TG',
  'CN',
  'BJ',
  'CY',
  'AF',
  'LV',
  'OM',
  'MR',
  'NI',
  'ME',
  'MH',
  'BG',
  'TJ',
  'UY',
  'ZA',
  'ZW',
  'BF',
  'CU',
  'NE',
  'NR',
  'MK',
  'NP',
  'NG',
  'BS',
  'BD',
  'UZ',
  'WS',
  'TH',
  'CA',
  'BE',
  'BR',
  'LY',
  'MY',
  'MN',
  'AZ',
  'BA',
  'AM',
  'CR',
  'TL',
  'TM',
  'TZ',
  'VE',
  'AL',
  'BW',
  'LK',
  'MX',
  'NA',
  'MZ',
  'LI',
  'MM',
  'CF',
  'BB',
  'TO',
  'TN',
  'AO',
  'BT',
  'CG',
  'ML',
  'JO',
  'IT',
  'GH',
  'SM',
  'PA',
  'SZ',
  'PW',
  'SL',
  'DE',
  'KH',
  'ET',
  'EC',
  'SN',
  'SY',
  'PT',
  'SO',
  'JM',
  'HR',
  'KI',
  'KZ',
  'IE',
  'KM',
  'GY',
  'GN',
  'FJ',
  'PG',
  'SK',
  'RO',
  'EG',
  'IS',
  'ID',
  'IQ',
  'HU',
  'EE',
  'ER',
  'FI',
  'GM',
  'SI',
  'PE',
  'QA',
  'ES',
  'HT'
] as const

export default codes
